import { onMounted } from 'vue'
import { onLCP, onTTFB } from 'web-vitals'
import { onCLS, onINP } from 'web-vitals/attribution'

type ClsPayload = {
    value: number
    viewport: string
    shiftTarget?: string
}

type InpPayload = {
    value: number
    target: string
    timing: string
}

type UseBrowserRumTrackingOptions = {
    onCLS: (payload: ClsPayload) => void
    onINP: (payload: InpPayload) => void
    onTTFB: (ttfb: number) => void
    onLCP: (lcp: number) => void
}

function getViewportString(): string {
    const width = Math.round(window.visualViewport?.width ?? window.innerWidth)
    const height = Math.round(window.visualViewport?.height ?? window.innerHeight)
    const dpr = window.devicePixelRatio || 1
    const dprStr = Number.isFinite(dpr) ? dpr.toFixed(2).replace(/\.00$/, '') : '1'
    return `${width}x${height}@${dprStr}`
}

function round(value: number): number {
    return Math.round(value)
}

function getInpTiming(inputDelay: number, processingDuration: number, presentationDelay: number): string {
    return `input:${round(inputDelay)},processing:${round(processingDuration)},presentation:${round(presentationDelay)}`
}

export function useBrowserRumTracking(options: UseBrowserRumTrackingOptions): void {
    onMounted(() => {
        onCLS((metric) => {
            options.onCLS({
                value: metric.value,
                viewport: getViewportString(),
                shiftTarget: metric.attribution.largestShiftTarget,
            })
        })

        onINP((metric) => {
            options.onINP({
                value: metric.value,
                target: metric.attribution.interactionTarget,
                timing: getInpTiming(
                    metric.attribution.inputDelay,
                    metric.attribution.processingDuration,
                    metric.attribution.presentationDelay,
                ),
            })
        })

        onTTFB((metric) => {
            options.onTTFB(metric.value)
        })

        onLCP((metric) => {
            options.onLCP(metric.value)
        })
    })
}
